// constants.js
export const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

// Origin of the backend server (no trailing slash, no /api path).
// Used to resolve relative media/API URLs returned by the backend.
export const API_ORIGIN = BASE_URL.replace(/\/api.*$/, '');

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI || 'http://localhost:8080/google/oauth/callback/';

export const FACEBOOK_CLIENT_ID = process.env.REACT_APP_FACEBOOK_CLIENT_ID || '';
export const FACEBOOK_REDIRECT_URI = process.env.REACT_APP_FACEBOOK_REDIRECT_URI || 'http://localhost:8080/facebook/oauth/callback/';

export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

// Public production origin for canonical / OG URLs. Canonicals must always point
// at the production domain, even when served from staging or localhost.
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://grids.matchmovemachine.com';

export const POSTHOG_API_KEY = process.env.REACT_APP_POSTHOG_API_KEY || '';
export const POSTHOG_API_HOST = process.env.REACT_APP_POSTHOG_API_HOST || '/api/mm';
export const POSTHOG_SESSION_RECORDING_SAMPLE_RATE = process.env.REACT_APP_POSTHOG_SESSION_RECORDING_SAMPLE_RATE || '0';

export default BASE_URL;
